// Shop by category: arrow pages the scroll-snap row; hidden when the row doesn't scroll (desktop).
if (!customElements.get('shop-by-category')) {
  customElements.define(
    'shop-by-category',
    class ShopByCategory extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-sbcat-track]');
        this.next = this.querySelector('[data-sbcat-next]');
        if (!this.track || !this.next) return;
        this.next.addEventListener('click', () => {
          const slide = this.track.querySelector('.sbcat__slide');
          const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
          const step = slide ? slide.getBoundingClientRect().width + gap : this.track.clientWidth * 0.8;
          const max = this.track.scrollWidth - this.track.clientWidth;
          this.track.scrollBy({ left: this.track.scrollLeft >= max - 2 ? -max : step });
        });
        this.update = () => {
          const tr = this.track.getBoundingClientRect();
          this.track.querySelectorAll('.sbcat__slide').forEach((slide) => {
            const r = slide.getBoundingClientRect();
            slide.classList.toggle('is-partial', r.left < tr.left - 2 || r.right > tr.right + 2);
          });
          const max = this.track.scrollWidth - this.track.clientWidth;
          this.next.hidden = max <= 2;
        };
        this.track.addEventListener('scroll', this.update, { passive: true });
        window.addEventListener('resize', this.update);
        this.update();
      }

      disconnectedCallback() {
        window.removeEventListener('resize', this.update);
      }
    }
  );
}
